import style from "./AccordionCard.module.css";
import { useState } from "react";
import AccordionPart from "./accordionPart";
// ICONS
import iconStar from "../images/icon-star.svg";

function AccordionCard() {
  const [activeNumber, setActiveNumber] = useState(null);
  const accordionComponents = [
    {
      clickNum: 1,
      title: "What is Frontend Mentor, and how will it help me?",
      content:
        `რომელმან შექმნა სამყარო ძალითა მით ძლიერითა,
          ზეგარდმო არსნი სულითა ყვნა ზეცით მონაბერითა,
          ჩვენ, კაცთა, მოგვცა ქვეყანა, გვაქვს უთვალავი ფერითა,
          მისგან არს ყოვლი ხელმწიფე სახითა მის მიერითა`,
    },
    {
      clickNum: 2,
      title: "Is Frontend Mentor free?",
      content:
        `ჰე, ღმერთო ერთო, შენ შეჰქმენ სახე ყოვლისა ტანისა,
          შენ დამიფარე, ძლევა მეც დათრგუნვად მე სატანისა,
          მომეც მიჯნურთა სურვილი, სიკვდიდმდე გასატანისა,
          ცოდვათა შესუბუქება, მუნ თანა წასატანისა.`,
    },
    {
      clickNum: 3,
      title: "Can I use Frontend Mentor projects in my portfolio?",
      content:
        `ვის ჰშვენის, - ლომსა, - ხმარება შუბისა, ფარ-შიმშერისა,
        - მეფისა მზის თამარისა, ღაწვ-ბადახშ, თმა-გიშერისა, -
        მას, არა ვიცი, შევჰკადრო შესხმა ხოტბისა, შე, რისა?
        მისთა მჭვრეტელთა ყანდისა მირთმა ხამს მართ, მი,
        შერისა.`,
    },
    {
      clickNum: 4,
      title: "How can I get help if I'm stuck on a challenge?",
      content:
        `თამარს ვაქებდეთ მეფესა სისხლისა ცრემლ-დათხეული,
        ვთქვენი ქებანი ვისნი მე არ-ავად გამორჩეული.
        მელნად ვიხმარე გიშრის ტბა და კალმად მე ნა რხეული,
        ვინცა ისმინოს, დაესვას ლახვარი გულსა ხეული.`,
    },
  ];
  const click = (clickNumber) => {
    if (activeNumber === clickNumber) {
      setActiveNumber(style.contentContHidden);
    } else {
      setActiveNumber(clickNumber);
    }
  };

  return (
    <>
      <div className={style.cardHeader}>
        <img src={iconStar} alt=" star icon" />
        <span className={style.faqs}>FAQs</span>
      </div>
      {accordionComponents.map((element) => {
        return (
          <AccordionPart
            key={element.clickNum}
            activeNumber={activeNumber}
            click={click}
            clickNum={element.clickNum}
            title={element.title}
            content={element.content}
          />
        );
      })}
    </>
  );
}

export default AccordionCard;
